import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './base.query';
import { API_PREFIX } from 'common/constants';

export const moduleProjectApi = createApi({
  reducerPath: 'moduleProjectApi',
  baseQuery: baseQuery,
  endpoints: (builder) => ({
    getProjectConfig: builder.query({
      query: (args: { projectId: string; filter?: any; requestFilters?: any }) => ({
        url: `${API_PREFIX.NEXTGEN}project-data/get-project-config`,
        method: 'POST',
        body: {
          request: {
            filters: args.requestFilters ?? [],
            sorts: [],
            aggregates: [],
            groups: [],
          },
          filter: args.filter ?? {},
          filterLabels: [],
          widget: 'project_config',
          includeAlignment: true,
        },
      }),
    }),
  }),
});

export const { useGetProjectConfigQuery } = moduleProjectApi;
